import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, role, roles }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  const allowed = roles || (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
